!(function () {
  function e() {
    subSliderInit(!0), sliderInit(!0), popupSliderInit(!0);
  }
  function i(e, t) {
    var o = e.clientHeight;
    (e.style.transitionProperty = 'height, margin, padding'),
      (e.style.transitionDuration = t + 'ms'),
      (e.style.boxSizing = 'border-box'),
      (e.style.overflow = 'hidden'),
      (e.style.height = o + 'px'),
      (e.style.paddingTop = '0'),
      (e.style.paddingBottom = '0'),
      (e.style.marginTop = '0'),
      (e.style.marginBottom = '0'),
      setTimeout(function () {
        (e.style.height = '0'),
          (e.style.paddingTop = '0'),
          (e.style.paddingBottom = '0'),
          (e.style.marginTop = '0'),
          (e.style.marginBottom = '0');
      }, 10),
      setTimeout(function () {
        (e.style.display = 'none'),
          e.style.removeProperty('height'),
          e.style.removeProperty('padding-top'),
          e.style.removeProperty('padding-bottom'),
          e.style.removeProperty('margin-top'),
          e.style.removeProperty('margin-bottom'),
          e.style.removeProperty('overflow'),
          e.style.removeProperty('transition-duration'),
          e.style.removeProperty('transition-property');
      }, t);
  }
  const t = () => {
      document.querySelectorAll('.about__accordion-toggle').forEach((r) => {
        r.addEventListener('click', () => {
          if (
            (document
              .querySelectorAll(
                '.product__info-container .about__accordion-toggle'
              )
              .forEach((e) => {
                e != r && e.classList.remove('active');
              }),
            document
              .querySelectorAll(
                '.product__info-container .about__accordion-toggle'
              )
              .forEach((e) => {
                e != r && i(e.nextElementSibling, 300);
              }),
            r.classList.contains('active'))
          )
            r.classList.remove('active'), i(r.nextElementSibling, 300);
          else {
            r.classList.add('active');
            {
              var e = r.nextElementSibling,
                t = 300;
              (e.style.overflow = 'hidden'),
                (e.style.height = '0'),
                (e.style.display = 'block');
              const o = e.scrollHeight;
              setTimeout(function () {
                e.style.height = o + 'px';
              }, 10),
                setTimeout(function () {
                  e.style.removeProperty('overflow'),
                    e.style.removeProperty('height');
                }, t);
            }
          }
        });
      });
    },
    o = () => {
      const e = document.querySelector(
        '.main-product .product-form__submit-wrapper'
      );
      if (e) {
        let t = !0,
          o = !1;
        const i = () => {
          t || o
            ? (e.closest('.product-form__buttons-row').removeAttribute('style'),
              e.classList.remove('fixed'))
            : e.classList.contains('fixed') ||
              ((e.closest('.product-form__buttons-row').style.minHeight =
                e.clientHeight + 'px')
            );
        };
        new IntersectionObserver(
          (e) => {
            var [e] = e;
            (t = e.isIntersecting),
              i(),
              console.log('from buttonObserver', t, o);
          },
          { root: null, rootMargin: '0px 0px 45px 0px', threshold: 0.01 }
        ).observe(document.querySelector('.product-form__buttons'));
        var r = new IntersectionObserver(
          (e) => {
            var [e] = e;
            (o = e.isIntersecting),
              i(),
              console.log('from footerObserver', t, o);
          },
          { root: null, rootMargin: '0px', threshold: 0.01 }
        );
        document.querySelector('.footer') &&
          r.observe(document.querySelector('.footer'));
      }
    };
  class r extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide(), window.pauseAllMedia();
    }
    show(e) {
      super.show(e), this.showActiveMedia();
    }
    showActiveMedia() {
      var e = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
      );
      'DEFERRED-MEDIA' == e.nodeName &&
        e.querySelector('template')?.content?.querySelector('.js-youtube') &&
        e.loadContent();
    }
  }
  customElements.define('product-modal', r),
    document.addEventListener('shopify:section:load', function () {
      t(), o(), e();
    }),
    e(),
    t(),
    o();
})();
